import styled, { keyframes } from 'styled-components'

const LoadingDots = ({ large = false }: { large?: boolean }) => (
    <LoadingDotsWrapper>
        <Dot style={{ animationDelay: '-0.32s' }} large={large} />
        <Dot style={{ animationDelay: '-0.16s' }} large={large} />
        <Dot large={large} />
    </LoadingDotsWrapper>
)

export default LoadingDots

const bounce = keyframes`
    0%, 80%, 100% {
        transform: scale(0);
    } 
    40% {
        transform: scale(1);
    }
`

const Dot = styled.div<{ large: boolean }>`
    width: ${({ large }) => (large ? '20px' : '8px')};
    height: ${({ large }) => (large ? '20px' : '8px')};
    margin: 0 4px;
    background-color: #c0c0c0;
    border-radius: 50%;
    display: inline-block;
    animation: ${bounce} 1.4s infinite ease-in-out both;
`

const LoadingDotsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const LoadingDotsBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100px;
`
